import classNames from "classnames";
import React from 'react';


const GotoPageEntire = ({
  page,
  key,
  currentPage,
  onChange,
  ...props
}) => {

  let classes = [
    "border",
    "font-medium",
    "inline-flex",
    "items-center",
    "px-4",
    "py-2",
    "relative",
    "text-sm"
  ];

  if (page === currentPage) {
    classes = [
      ...classes,
      "bg-indigo-50",
      "border-indigo-500",
      "text-indigo-600",
      "z-10"
    ]
  } else {
    classes = [
      ...classes,
      "border-gray-300",
      "text-gray-500",
      "hover:bg-gray-50",
      "bg-white"
    ]
  }

  return (<a
    key={key}
    href="#"
    onClick={(event) => onChange(event, page)}
    aria-current="page"
    className={classNames(classes)}
  >
    {page}
  </a>)
};

export default GotoPageEntire;
